import { useRuntimeConfig } from "#app";
export const useConfig = () => {
  const runtimeConfig = useRuntimeConfig();
  const config = {
    API_URL: runtimeConfig.public.API_URL,
    CLIKMA_URL: runtimeConfig.public.CLIKMA_URL,
    USER_ORIGIN: runtimeConfig.public.USER_ORIGIN
  };
  return {
    config
  };
};
